import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterSelectAsync } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { mappedFacilityTypes } from '../../enums/FacilityTypes';
import {
  DisplayGuid,
  DisplayDate,
  DisplayType
} from '../items';
import AddEntityButton from '../misc/AddEntityButton';

const resultsCount = 15;

class FacilitiesInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { facilities: { searchFacility } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchFacility({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, categories, api } = this.props;
    const mappedCategories = categories.map(({ Name }) => ({ value: Name, label: Name }));
    const {
      providers: { lookupByNameOrId: lookupProvider }
    } = api;
    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Facilities page'
              documentDescription='Facilities page'
            />

            <h2 className='main-page-header'>
              Facilities
              <AddEntityButton to='/facility' />
            </h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                facilityId,
                name,
                type,
                category,
                providerId
              }, updatedKey) => {
                if (updatedKey !== 'facilityId') {
                  return {
                    name,
                    type,
                    category,
                    providerId
                  };
                }
                return { facilityId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='facilityId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='facilityId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='name'>
                      Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='name'
                      placeholder='Filter by name'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='type'>
                      Type
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='type'
                      options={mappedFacilityTypes}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='category'>
                      Category
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='category'
                      options={mappedCategories}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='providerId'>
                      Provider
                    </label>
                    <FilterSelectAsync
                      className='filter-select'
                      data={formData}
                      debounce
                      update={update}
                      name='providerId'
                      loadOptions={async inputValue => lookupProvider(inputValue)}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'facilities',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/facility/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Name',
                    label: 'Name',
                    type: 'string'
                  },
                  {
                    property: 'Type',
                    label: 'Type',
                    type: 'string',
                    render: ({ Type }) => <DisplayType>{Type}</DisplayType>
                  },
                  {
                    property: 'Category',
                    label: 'Category',
                    type: 'string'
                  },
                  {
                    property: 'CreatedAt',
                    label: 'Created At',
                    render: ({ CreatedAt }) => <DisplayDate>{CreatedAt}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Facilities = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(FacilitiesInternal)
));

Facilities.requiresLogin = true;
Facilities.propTypes = { isLoggedIn: PropTypes.bool };

export default Facilities;